module.exports = __webpack_public_path__ + "img/image_album_death_is_coming.17e5bf91.jpg";